import React from 'react';
import { Dropdown } from '@fourthwall/components';
import { AnalyticsSelectTool } from '../AnalyticsSelectTool/AnalyticsSelectTool';
export const AnalyticsGroupBySelect = ({ value, options, onSelect, }) => {
    const handleSelect = (option, close) => {
        onSelect(option);
        close();
    };
    return (React.createElement(AnalyticsSelectTool, { label: `Group: ${value.label}`, renderContent: ({ close }) => options.map((option) => (React.createElement(Dropdown.Item, { active: value.value === option.value, key: option.value, label: option.label, onClick: () => handleSelect(option, close) }))) }));
};
